import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AccordionModule } from 'primeng/accordion';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { BadgeModule } from 'primeng/badge';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CardModule } from 'primeng/card';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipModule } from 'primeng/chip';
import { DialogModule } from 'primeng/dialog';
import { DrawerModule } from 'primeng/drawer';
import { DropdownModule } from 'primeng/dropdown';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { ListboxModule } from 'primeng/listbox';
import { MenuModule } from 'primeng/menu';
import { MultiSelectModule } from 'primeng/multiselect';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { PaginatorModule } from 'primeng/paginator';
import { RadioButtonModule } from 'primeng/radiobutton';
import { RippleModule } from 'primeng/ripple';
import { SidebarModule } from 'primeng/sidebar';
import { SkeletonModule } from 'primeng/skeleton';
import { SliderModule } from 'primeng/slider';
import { SplitButtonModule } from 'primeng/splitbutton';
import { StepperModule } from 'primeng/stepper';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';

@NgModule({
  imports: [
    CommonModule,
    ButtonModule,
    RippleModule,
    DialogModule,
    TooltipModule,
    ToastModule,
    MultiSelectModule,
    CardModule,
    ListboxModule,
    SliderModule,
    InputTextModule,
    DropdownModule,
    TableModule,
    MenuModule,
    DialogModule,
    CheckboxModule,
    SplitButtonModule,
    CalendarModule,
    PaginatorModule,
    StepperModule,
    InputSwitchModule,
    AccordionModule,
    BadgeModule,
    AutoCompleteModule,
    RadioButtonModule,
    ChipModule,
    SidebarModule,
    OverlayPanelModule,
    SkeletonModule,
    DrawerModule,
  ],
  exports: [
    ButtonModule,
    RippleModule,
    DialogModule,
    TooltipModule,
    ToastModule,
    MultiSelectModule,
    CardModule,
    ListboxModule,
    SliderModule,
    InputTextModule,
    DropdownModule,
    TableModule,
    MenuModule,
    DialogModule,
    CheckboxModule,
    SplitButtonModule,
    CalendarModule,
    PaginatorModule,
    StepperModule,
    InputSwitchModule,
    AccordionModule,
    BadgeModule,
    AutoCompleteModule,
    RadioButtonModule,
    ChipModule,
    SidebarModule,
    OverlayPanelModule,
    SkeletonModule,
    DrawerModule,
  ],
})
export class PrimeNgModule {}
